<ion-app mode="ios">
	<ion-split-pane contentId="main-content">
		<ion-menu contentId="main-content" type="overlay" class="lg:w-[320px]">
			<!-- <ion-header mode="ios" class="ion-no-border lg:hidden">
				<ion-toolbar>
					<ion-buttons slot="end">
						<ion-menu-button>
							<ion-icon name="close-outline" class="text-[26px]"></ion-icon>
						</ion-menu-button>
					</ion-buttons>
				</ion-toolbar>
			</ion-header> -->
			<ion-content *ngIf="authService.user">
				<div class="pl-4 pt-4">
					<img src="assets/logo.png" width="60px" />
				</div>
				<ion-list id="inbox-list">
					<ion-list-header>
						IT Activity Tracker
					</ion-list-header>
					<ion-note>
						Legacy Cleaning Services
					</ion-note>
					<ion-note>
						Legacy Cleaning Services
					</ion-note>

					<div class="mt-4 w-full h-[1px] bg-gray-200"></div>

						<ion-menu-toggle *ngIf="authService.user.access.board" auto-hide="false">
							<ion-item routerDirection="root" routerLink="/board" lines="none" detail="false" routerLinkActive="selected">
								<ion-icon aria-hidden="true" slot="start" name="analytics-outline"></ion-icon>
								<ion-label>
									Dashboard
								</ion-label>
							</ion-item>
						</ion-menu-toggle>

						<ion-menu-toggle *ngIf="authService.user.access.updates" auto-hide="false">
							<ion-item routerDirection="root" routerLink="/updates" lines="none" detail="false" routerLinkActive="selected">
								<ion-icon aria-hidden="true" slot="start" name="newspaper-outline"></ion-icon>
								<ion-label>
									Updates
								</ion-label>
							</ion-item>
						</ion-menu-toggle>

						<ion-menu-toggle *ngIf="authService.user.access.add_request" auto-hide="false">
							<ion-item routerDirection="root" routerLink="/add-request" lines="none" detail="false" routerLinkActive="selected">
								<ion-icon aria-hidden="true" slot="start" name="add-circle-outline"></ion-icon>
								<ion-label>
									Add request
								</ion-label>
							</ion-item>
						</ion-menu-toggle>

						<ion-menu-toggle *ngIf="authService.user.access.status" auto-hide="false">
							<ion-item routerDirection="root" routerLink="/status" lines="none" detail="false" routerLinkActive="selected">
								<ion-icon aria-hidden="true" slot="start" name="flash-outline"></ion-icon>
								<ion-label>
									System status
								</ion-label>
							</ion-item>
						</ion-menu-toggle>

						<ion-menu-toggle *ngIf="authService.user.access.weekly_scorecard" auto-hide="false">
							<ion-item routerDirection="root" routerLink="/weekly-scorecard" lines="none" detail="false" routerLinkActive="selected">
								<ion-icon aria-hidden="true" slot="start" name="star-outline"></ion-icon>
								<ion-label>
									Weekly Scorecard
								</ion-label>
							</ion-item>
						</ion-menu-toggle>

						<ion-menu-toggle auto-hide="false">
							<ion-item (click)="logout()" lines="none" detail="false" class="cursor-pointer">
								<ion-icon aria-hidden="true" slot="start" name="log-out-outline"></ion-icon>
								<ion-label>
									Logout
								</ion-label>
							</ion-item>
						</ion-menu-toggle>

				</ion-list>
			</ion-content>
		</ion-menu>
		<ion-router-outlet id="main-content"></ion-router-outlet>
	</ion-split-pane>
</ion-app>
